import { h, JSX, FunctionalComponent } from "preact";
import { Icon } from "@uw/icons/types";
const defaultStyle = {
  width: "24px",
  height: "24px",
  display: "flex",
};
const SvgIcon = (props: JSX.SVGAttributes<any>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 16" {...props}>
    <g fill="none" fill-rule="evenodd">
      <path
        stroke="currentColor"
        stroke-linejoin="round"
        stroke-width={1.5}
        d="M10.185 7.773 6 1 1.75 7.885A4.416 4.416 0 0 0 1 10.332C1 12.911 3.239 15 6 15s5-2.09 5-4.667c0-.886-.742-2.438-.75-2.449l-.065-.111Z"
      />
      <path
        fill="currentColor"
        d="M6 15c2.761 0 5-2.09 5-4.667 0-.886-.742-2.438-.75-2.449l-.065-.111L6 1"
      />
    </g>
  </svg>
);
export const ColorBlindIcon: FunctionalComponent<Icon> = ({
  className,
  svgAttrs = {
    width: "100%",
    height: "100%",
  },
  key,
  jsx,
  children,
  ref,
  ...styles
}) => (
  <span
    className={className}
    style={{
      ...defaultStyle,
      ...styles,
    }}
  >
    <SvgIcon {...svgAttrs} />
  </span>
);
